import {AxiosResponse} from 'axios';
import {orgAPI} from '@/core/api';
import {API_URL} from '../enums/api-url.enum';
import {ICreatePrinttableTemplate} from '../types/organization-printtable.interface';

class PrintableService {
	static getQRCode = async (websiteUrl: string): Promise<AxiosResponse> =>
		orgAPI.get(`${API_URL.GET_WEBSITE_QR_CODE}?websiteUrl=${websiteUrl}`, {
			responseType: 'arraybuffer',
		});

	static getBigSheet = async (itemId: number): Promise<AxiosResponse> =>
		orgAPI.get(`${API_URL.GET_BIG_SHEET_ITEM}?itemId=${itemId}`, {
			responseType: 'arraybuffer',
		});

	static getGuestList = async (id: number, type: string): Promise<AxiosResponse<any>> =>
		orgAPI.get(`${API_URL.GET_PDF_GUEST_LIST}/${id}?type=${type}`, {responseType: 'arraybuffer'});

	static getPrinttableTemplate = async (eventId: number): Promise<AxiosResponse<any>> =>
		orgAPI.get(`${API_URL.GET_PRINTTABLE_TEMPLATE}/${eventId}`);

	static createOrUpdatePrinttableTemplate = async (reqBody: ICreatePrinttableTemplate): Promise<AxiosResponse<any>> =>
		orgAPI.post(`${API_URL.GET_PRINTTABLE_TEMPLATE}`, reqBody);

	static presignPrinttableTemplate = async (): Promise<AxiosResponse> =>
		orgAPI.get(`${API_URL.PRESIGN_PRINTTABLE_TEMPLATE}`);
}

export {PrintableService};
